import { render, staticRenderFns } from "./InvoiceImportDetailsMain.vue?vue&type=template&id=40397b30&"
import script from "./InvoiceImportDetailsMain.vue?vue&type=script&lang=js&"
export * from "./InvoiceImportDetailsMain.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceImportDetailsMain.vue?vue&type=style&index=0&id=40397b30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports